// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__n6Qdq","tableExams":"styles_tableExams__EglPP","tableExams_thead":"styles_tableExams_thead__mP+sJ","tableExams_tbody":"styles_tableExams_tbody__SKmb1"};